export default __webpack_public_path__ + "static/dio-b3d84cde661d6c78503ebda07a98f9f2.png";